import React, { useEffect } from "react";
import {
  CHANGE_BO,
  CHANGE_BO_TYPE,
  CHANGE_EO,
  CHANGE_FREQUENCY,
} from "../../../../actions/create-bot-type";
import BooleanView from "../BooleanView";
import SliderView from "../SliderView";
import TutorialPopup from "../../../help/TutorialPopup";
import * as HelpContent from "../../../../utils/HelpContent";
import { useDispatch, useSelector } from "react-redux";
import { isLong, isMarginShort } from "../../../../utils/Utils";
import { Frequencies, FrequencyValues,FrequencyValuesSimple,FrequenciesSimple,BotType, SUB_TIER, FrequencyValuesPro, FrequenciesPro, ExtraOrderCount } from "../../../../Const";
import { checkSub, isPro } from "../../../../utils/SubUtils";
import MinimumPriceGapModule from "../MinimumPriceGapModule";

const NormalParamsView = (props) => {
  const { newBot,t } = props;
  const orderType = newBot.baseOrderType;
  const isEditing  = newBot.isEditing;
  const isMomentum = newBot.botType==BotType.momentum;
  const extraOrders = !isEditing && isMomentum?1:newBot.extraOrderNum;
  const frequency = newBot.frequency;
  const baseOrder = newBot.baseOrder;
  const fund = newBot.initFund;
  const subscription = useSelector(
    (state) => state.auth.user.user_subscription
  );
  const isProffessional = isPro(subscription)
  const { subPremium, subTier } = checkSub(subscription);
  const tradingFreqValues = isProffessional?(newBot.botType==BotType.simple?FrequencyValues:FrequencyValuesPro):(newBot.botType==BotType.simple?FrequencyValuesSimple:FrequencyValues)
  const tradingFreqencies = isProffessional?(newBot.botType==BotType.simple?Frequencies:FrequenciesPro):(newBot.botType==BotType.simple?FrequenciesSimple:Frequencies)
  const isExitBot = newBot.botType==BotType.exit;
  const isSimpleBot = newBot.botType==BotType.simple;
  
  const dispatch = useDispatch();
  const tfValue = tradingFreqValues.indexOf(frequency) >0? tradingFreqValues.indexOf(frequency) : 0;
  const currentCoin = (isMarginShort(newBot.strategy)|| isLong(newBot.strategy))
    ? newBot.quoteCoin
    : newBot.baseCoin;

  const baseOrderChanged = (val) => {
    dispatch({
      type: CHANGE_BO,
      payload: val,
    });
  };

  const orderTypeChanged = (val) => {
    dispatch({
      type: CHANGE_BO_TYPE,
      payload: val,
    });
  };

  const extraOrdersChanged = (val) => {
    dispatch({
      type: CHANGE_EO,
      payload: val,
    });
  };

  const frequencyChanged = (val) => {
    dispatch({
      type: CHANGE_FREQUENCY,
      payload: val,
    });
  };

  const formatExtraOrder = (value) => {
    if (value == 0) {
      return t("disable");
    }
    return `${value} (${(100 - baseOrder) / value}%)`;
  };
  const formatBaseOrder = (value) =>
    `${((fund * value) / 100).toFixed(4)} ${currentCoin} (${value}%)`;
  const formartFrequency = (value) => tradingFreqencies[value];
  useEffect(() => {
      frequencyChanged(tradingFreqValues[tfValue])
  }, [tfValue]);
  return (
    <>
      
      {!isExitBot && <SliderView
        title={t("bo-limit")}
        step={5}
        min={5}
        formatLabel={formatBaseOrder}
        onChange={baseOrderChanged}
        value={baseOrder}
        withInput={true}
        tutorial={<TutorialPopup content={t("baseOrder-help")} />}
      /> }
     
      {!isExitBot &&<BooleanView
          title={t("bo-type")}
          firstButton="static"
          secondButton="dynamic"
          selected={orderType}
          onSelect={orderTypeChanged}
          customClass="blue-green"
          tutorial={<TutorialPopup content={t("base-order-type-help")} />}
        />}
      
      {!isExitBot && <><SliderView
          title={t("eo")}
          min={0}
          max={ExtraOrderCount[newBot.botType]}
          value={extraOrders}
          formatLabel={formatExtraOrder}
          onChange={extraOrdersChanged}
          withInput={true}
          appendText=" "
          tutorial={<TutorialPopup content={t("extra-order-help")} />}
          
        />
        <MinimumPriceGapModule newBot={newBot} t={t}></MinimumPriceGapModule>
        </> }
      <div style={{ marginTop: 20 }}>
        <SliderView
          title={t("tf")}
          max={tradingFreqValues.length - 1}
          value={tfValue}
          formatLabel={formartFrequency}
          onChange={(value) => frequencyChanged(tradingFreqValues[value])}
          tutorial={<TutorialPopup content={t("trading-freq-help")} />}
        />
      </div>
    </>
  );
};

export default NormalParamsView;
